import { render, staticRenderFns } from "./Footbar.vue?vue&type=template&id=2050dd86&scoped=true"
import script from "./Footbar.vue?vue&type=script&lang=js"
export * from "./Footbar.vue?vue&type=script&lang=js"
import style0 from "./Footbar.vue?vue&type=style&index=0&id=2050dd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050dd86",
  null
  
)

export default component.exports